/**
 * Reusable campaign background component
 * Handles background images and styling for campaign sections
 */
import { memo, type FC } from 'react';
import { useCampaignSectionBase } from '../../_hooks/useCampaignSection';
import styles from './CampaignSectionBackground.module.css';

interface CampaignBackgroundProps {
  backgroundImage?: string;
  backgroundColor?: string;
  sectionName: string;
  isActive: boolean;
  additionalProps?: Record<string, unknown>;
}

const CampaignSectionBackground: FC<CampaignBackgroundProps> = ({
  backgroundImage,
  backgroundColor,
  sectionName,
  isActive,
  additionalProps
}) => {
  const { createContainerProps, isInMultiView } = useCampaignSectionBase({ name: sectionName }, isActive);
  
  const containerProps = createContainerProps({
    'data-has-background': backgroundImage || backgroundColor ? 'true' : 'false',
    ...additionalProps
  });

  // Only show background in multi-view mode
  if (!isInMultiView || (!backgroundImage && !backgroundColor)) {
    return null;
  }

  const backgroundStyle: React.CSSProperties = {};
  if (backgroundImage) {
    backgroundStyle.backgroundImage = `url(${backgroundImage})`;
  }
  if (backgroundColor) {
    backgroundStyle.backgroundColor = backgroundColor;
  }

  return (
    <div
      className={styles.CampaignSectionBackground}
      style={backgroundStyle}
      {...containerProps}
    />
  );
};

export default memo(CampaignSectionBackground);
